const healthAndBeautyBusinessSchema = (master) => {
    const verifiedObj = _serializeMaster(master);
    return {
        "@context": "https://schema.org",
        "@type": "HealthAndBeautyBusiness",
        "name": `${verifiedObj.name}`,
        "image": `${verifiedObj.image}`,
        "description": `${verifiedObj.description}`,
        ...(verifiedObj.ratingCount > 0 && {
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": `${verifiedObj.ratingValue}`,
                "bestRating": verifiedObj.bestRating && `${verifiedObj.bestRating}`,
                "worstRating": verifiedObj.worstRating && `${verifiedObj.worstRating}`,
                "ratingCount": `${verifiedObj.ratingCount}`,
                "reviewCount": verifiedObj.reviewCount && `${verifiedObj.reviewCount}`,
            }}),
        ...(verifiedObj.reviews.length && {
            "review": verifiedObj.reviews.map((review) => ({
                "@type": "Review",
                "reviewBody": `${review.reviewBody}`,
                "reviewRating": review.ratingValue && {
                    "@type": "Rating",
                    "ratingValue": `${review.ratingValue}`,
                    "bestRating": review.bestRating && `${review.bestRating}`,
                    "worstRating": review.worstRating && `${review.worstRating}`
                },
                "datePublished": `${review.datePublished}`,
                "author": {"@type": "Person", "name": `${review.authorName}`},
                "publisher": review.publisherName && {"@type": "Organization", "name": `${review.publisherName}`},
                "itemReviewed": review.itemReviewed
            }))}),
        ...(verifiedObj.address && {
            "address": {
                "@type": "PostalAddress",
                ...(verifiedObj.address.streetAddress && { "streetAddress": `${verifiedObj.address.streetAddress}` }),
                ...(verifiedObj.address.addressLocality && { "addressLocality": `${verifiedObj.address.addressLocality}` }),
                ...(verifiedObj.address.addressRegion && { "addressRegion": `${verifiedObj.address.addressRegion}` }),
                ...(verifiedObj.address.postalCode && { "postalCode": `${verifiedObj.address.postalCode}` }),
                ...(verifiedObj.address.addressCountry && { "addressCountry": `${verifiedObj.address.addressCountry}` })
            }
        }),
        ...(verifiedObj.priceRange && { "priceRange": `${verifiedObj.priceRange}` }),
        ...(verifiedObj.url && { "url": `${verifiedObj.url}` }),
        ...(verifiedObj.openingHours.length > 0 && { "openingHours": verifiedObj.openingHours }),
        ...(verifiedObj.geo && {
            "geo": {
                "@type": "GeoCoordinates",
                ...(verifiedObj.geo.latitude && { "latitude": `${verifiedObj.geo.latitude}` }),
                ...(verifiedObj.geo.longitude && { "longitude": `${verifiedObj.geo.longitude}` })
            }
        }),
        ...(verifiedObj.sameAs.length > 0 && { "sameAs": verifiedObj.sameAs }),
        ...(verifiedObj.founderName && {
            "founder": {
                "@type": "Person",
                "name": `${verifiedObj.founderName}`
            }
        }),
        ...(verifiedObj.areaServed && {
            "areaServed": {
                "@type": "Place",
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": `${verifiedObj.areaServed}`
                }
            }
        }),
        ...(verifiedObj.serviceType && { "serviceType": `${verifiedObj.serviceType}` }),
        ...(verifiedObj.hasMap && { "hasMap": `${verifiedObj.hasMap}` }),
        ...(verifiedObj.bookingUrl && { "bookingUrl": `${verifiedObj.bookingUrl}` }),
        ...(verifiedObj.paymentAccepted.length > 0 && { "paymentAccepted": verifiedObj.paymentAccepted })
    };
}

const _serializeMaster = (master) => {
    return {
        name: master.name || "Unknown",
        image: master.image || "https://beautycils.app/fr/images/beauty.png",
        description: master.description || "No description available",
        ratingValue: master.ratingValue || 0,
        ratingCount: master.ratingCount || 0,
        reviews: (master.reviews || []).map((review) => ({
            ...review,
            reviewBody: review.reviewBody || "No comment available",
            authorName: review.authorName || "unknown",
        })),
        address: master.address || null,
        priceRange: master.priceRange || null,
        url: master.url || null,
        openingHours: Array.isArray(master.openingHours) ? master.openingHours.filter(Boolean) : [],
        geo: (master.geo && (master.geo.latitude || master.geo.longitude)) ? master.geo : null,
        sameAs: Array.isArray(master.sameAs) ? master.sameAs.filter(Boolean) : [],
        founderName: master.founderName || null,
        areaServed: master.areaServed || null,
        serviceType: master.serviceType || null,
        hasMap: master.hasMap || null,
        bookingUrl: master.bookingUrl || null,
        paymentAccepted: Array.isArray(master.paymentAccepted) ? master.paymentAccepted.filter(Boolean) : []
    }
}

export {
    healthAndBeautyBusinessSchema
}
